import Illusion from 'illusionjs'
import Relationship from '.'
import Model from '../Model'
import QueryBuilder from '../QueryBuilder'
import { Builder } from '../Builder'

export class BelongsTo extends Relationship {

    protected _ownerKey: string

    protected _foreignKey: string

    constructor(relativeBuilder: Builder & QueryBuilder, currentModel: Model, foreignKey: string, ownerKey: string) {

		super(relativeBuilder, currentModel);

		this._ownerKey = ownerKey

        this._foreignKey = foreignKey

		this.addDefaultConstraints()
    }
    
    protected addDefaultConstraints(): void {

		if (Relationship.constraints) {

            const currentModel = this.getCurrentModel() as any
				
			this.getRelativeBuilder().where(this.getOwnerKey(), currentModel[this.getForeignkey()])
		}
    }

    protected getForeignkey(): string {

        return this._foreignKey
    }

    protected getOwnerKey(): string {
        
        return this._ownerKey
	}
	
	public addPersistentConstraints(currentModels: Model[]): void {

		this.getRelativeBuilder().whereIn(this.getOwnerKey(), this.getCurrentModelsId(currentModels));
    }

    public getCurrentModelsId(currentModels: Model[]): string[] {

        return currentModels.map((model: any) => {

            return model[this.getForeignkey()]
        })
    }

	public match(currentModels: Model[], relativeModels: Model[], relativeName: string): boolean {

		const groupParentModelResultByPrimaryKey = this.setPrimaryKeyAsResultIndex(relativeModels)

        currentModels.forEach((model: any) => {

			const childForeignId = model[this.getForeignkey()]

            // if(childForeignId in groupParentModelResultByPrimaryKey) {

                model.setRelative(relativeName, this.getRelationValue(groupParentModelResultByPrimaryKey[childForeignId] || []))
            // }
        })

        return true
	}

	protected setPrimaryKeyAsResultIndex(relativeModels: Model[]): Record<any, any> {
		
		const ownerKey: any = this.getOwnerKey()

        const groupParentModelResultByPrimaryKey = relativeModels.reduce<Record<any, any>>((result, row: any) => {
			
			const ownerId = row[ownerKey]

            if(ownerId in result) {
                result[ownerId].push(row)
            } else {
                result[ownerId] = [row]
            }

            return result
		}, {})
		
		return groupParentModelResultByPrimaryKey
	}
	
	protected getRelationValue(value: Model[]): Model {

		return value[0] || null
	}

}

export default Illusion<typeof BelongsTo>(BelongsTo)